import { DeleteCompanyReportService } from './delete-company-report';
import { GetCompanyReportsService } from './get-company-reports.service';
import { GetCompanyReportService } from './get-company-report.service';
import { Injectable } from '@angular/core';
import { SetCompanyReportService } from './set-company-report.service';
import { GenerateReportPreviewService } from './generate-report-preview.service';
import { GenerateTransientReportPreviewService } from './generate-transient-report-preview.service';

@Injectable()
export class ReportCenterService {
    constructor(
        public getReportsService: GetCompanyReportsService,
        public deleteReportService: DeleteCompanyReportService,
        public getReportService: GetCompanyReportService,
        public setReportService: SetCompanyReportService,
        public generateReportPreviewService: GenerateReportPreviewService,
        public generateTransientReportPreviewService: GenerateTransientReportPreviewService
    ) {}
}
